module.exports = __webpack_public_path__ + "img/Einschulungsgrinsen.4381d42c.jpg";